import { FilterValue, useAsyncDebounce, UseGlobalFiltersState } from 'react-table'
import React, { useState } from 'react'
import { IconName } from '~components/Icon'
import { Input } from '~components/Form'

type Props<D extends object> = UseGlobalFiltersState<D> & {
  onSetGlobalFilter: (filterValue: FilterValue) => void
  placeholder?: string
  isDisabled: boolean
}

const TableGlobalFilter = <D extends object>({ globalFilter, onSetGlobalFilter, placeholder = 'Search', isDisabled = false }: Props<D>) => {
  const [value, setValue] = useState(globalFilter)
  const onChange = useAsyncDebounce((filter: FilterValue) => {
    onSetGlobalFilter(filter || undefined)
  }, 200)

  const handleValueChange = (newValue: string) => {
    setValue(newValue)
    onChange(newValue)
  }

  return <Input size="small" onValueChange={handleValueChange} disabled={isDisabled} value={value} placeholder={placeholder} icon={IconName.search} />
}

export default TableGlobalFilter
